import { render, staticRenderFns } from "./informationDetails.component.vue?vue&type=template&id=41f5f384"
import script from "./informationDetails.component.ts?vue&type=script&lang=ts&external"
export * from "./informationDetails.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports